import React, { useState, useEffect } from "react";

import Corpo from "../components/Corpo";
import Popup from "../components/Popup";

export default function TabEstudo(props) {
  const [popupMaterial, setPopupMaterial] = useState(true);

  let cancela = () => {
    props.history.goBack();
  };

  let confirma = () => {
    window.open("https://uc.sebrae.com.br/pagina/conhecigame-material-de-estudo", "_blank");
    props.history.goBack();
  };

  useEffect(() => {
    const abortController = new AbortController();

    setPopupMaterial(true);

    return function cleanup() {
      abortController.abort();
    };
  }, [setPopupMaterial]);

  return (
    <Corpo {...props}>
      <Popup
        title="Material de Estudo"
        show={popupMaterial}
        botoes={[
          { texto: "Cancelar", acao: () => cancela() },
          { texto: "Confirmar", acao: () => confirma() },
        ]}
      >
        <span>
          Você será redirecionado ao portal da Universidade Corporativa para conteúdo relacionado ao tema.
        </span>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Popup>

      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-sobre pane pane-game">
          <div className="content scroll-content ionic-scroll  has-tabs-top">
            <div className="scroll">
              <h2>MATERIAL DE ESTUDO</h2>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
